module.exports = __webpack_public_path__ + "01_bob_brown.42878e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_bob_brown.png
// module id = EdWe
// module chunks = 0